import React, {Fragment} from "react";
import Portal from "../../../layout/Portal";
import Modal from "../../../layout/Modal";
import Button from "../../../form/Button";
import SelectorImage from "../../../form/SelectorGrid/SelectorImage";
import SelectorGrid from "../../../form/SelectorGrid/SelectorGrid";
import classNames from 'classnames';
import {ImageTemplate} from "../../../form/SelectorGrid/SelectorImage";
import {getComponentConfig, loadComponentById} from "../../../../utils/components";
import ContentLoader from "../../../layout/ContentLoader";
import {postData} from "../../../../utils/request";
import Select from "../../../form/Select";
import {ComponentName, optionsTemplate, remoteLanguageFormatter} from "../../../../utils/formatters";

export default class FolderButton extends React.Component {

    state = {
        opened: false,
        selection: [],
        history: [
            {
                filter: [],
                groupBy: ["component"]
            }
        ],
        currentHistory: 0,
        componentConfig: null,
        showOnlySelected: false,
        isLoading: false
    }

    componentDidMount() {
        if (!this.state.componentConfig) {
            this.config = getComponentConfig("figure");
            this.config.then((componentConfig) => {
                this.setState({componentConfig});
            });
        }
    }

    componentWillUnmount() {
        this.config && this.config.abort();
    }

    onSelection = (selection) => {
        if (this.isSelectable()) {
            let items = [...this.state.selection, ...selection.value];
            let flags = [], output = [];
            items.map((item, i) => {
                if(flags[items[i][this.state.componentConfig.idfield]]) {
                    output.splice(output.findIndex((oitem) => oitem[this.state.componentConfig.idfield] === item[this.state.componentConfig.idfield]), 1);
                    return;
                }
                flags[items[i][this.state.componentConfig.idfield]] = true;
                output.push(items[i]);
            });
            this.setState({selection: output});
        } else {
            let nextState = {};
            if (this.state.history[this.state.currentHistory].groupBy.length === 1) {
                nextState = {
                    groupBy: [
                        ...this.state.history[this.state.currentHistory].groupBy,
                        "component_id"
                    ],
                    filter: [
                        {
                            field: "component",
                            value: selection.value[0].component
                        }
                    ]
                };
            } else if (this.state.history[this.state.currentHistory].groupBy.length === 2) {
                nextState = {
                    groupBy: [
                        ...this.state.history[this.state.currentHistory].groupBy
                    ],
                    filter: [
                        {
                            field: "component",
                            value: selection.value[0].component
                        },{
                            field: "component_id",
                            value: selection.value[0].component_id
                        }
                    ]
                };
            }
            this.setState({
                ...nextState,
                history: [...this.state.history.slice(0, this.state.currentHistory + 1), {...nextState}],
                currentHistory: this.state.currentHistory + 1
            });
        }
    }

    onNext = () => {
        this.setState({
            currentHistory: this.state.currentHistory + 1
        });
    }

    onBack = () => {
        this.setState({
            currentHistory: this.state.currentHistory - 1
        });
    }

    isSelectable = () => {
        return this.state.showOnlySelected || (this.state.history[this.state.currentHistory].groupBy.length === 2 && this.state.history[this.state.currentHistory].filter.length === 2);
    }

    rowTemplate = (props) => {
        if (this.isSelectable()) {
            return <ImageTemplate {...props} />
        } else {
            const {image, onSelectionChange, isSelected} = props;
            let title = null;
            if (this.state.history[this.state.currentHistory].groupBy.length === 1) {
                title = <div className="title">{remoteLanguageFormatter("figure")(image.component)}</div>;
            } else if (this.state.history[this.state.currentHistory].groupBy.length === 2) {
                title = <div className="title"><ComponentName component={image.component} component_id={image.component_id}>{remoteLanguageFormatter("figure")(image.component)}{" (#" + image.component_id + ")"}</ComponentName></div>;
            }
            return <div>
                <div className="folder-effect" style={{backgroundImage: `url('${image.url}')`}}/>
                <div className="folder-effect" style={{backgroundImage: `url('${image.url}')`}}/>
                <div onClick={(e) => onSelectionChange(e, image)} className={classNames("image", {active: isSelected(image)}, props.className)} style={{backgroundImage: `url('${image.url}')`}}>
                    <img src={image.url} />
                    {title}
                    <span className="file">
                        <span className="path">{image.path}</span>
                        <span className="name">{image.name}</span>
                    </span>
                </div>
            </div>
        }
    }

    render() {
        if (!this.state.componentConfig) {
            return <ContentLoader/>;
        }
        const props = {};
        if (this.state.showOnlySelected) {
            props.selection = this.state.selection;
            if (this.state.selection.length > 0) {
                props.filter = {
                    field: this.state.componentConfig.idfield,
                    value: this.state.selection.map((item) => item[this.state.componentConfig.idfield]),
                    operator: 'in'
                };
            } else {
                props.filter = {
                    field: this.state.componentConfig.idfield,
                    value: -1
                };
            }
            props.pageSize = 0;
        } else {
            props.selection = this.isSelectable() ? this.state.selection : [];
            props.filter = this.state.history[this.state.currentHistory].filter;
            props.groupBy = {by: this.state.history[this.state.currentHistory].groupBy};
            props.pageSize = this.isSelectable() ? 0 : 15;
        }
        if (!this.state.showOnlySelected) {
            if (props.filter) {
                props.filter = [...props.filter];
            } else {
                props.filter = [];
            }
            if (props.filter.length > 0) {
                if (props.filter[0].value === this.props.component) {
                    props.filter.push({field: "component_id", value: this.props.component_id, operator: "!="});
                }
            }
        }
        const buttonProps = {...this.props};
        delete buttonProps.onComplete;
        return (
            <Fragment>
                <Portal>
                    <Modal
                        state={this.state.opened}
                        size="large"
                        header="Képtár"
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default", disabled: this.state.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    this.setState({
                                        isLoading: false,
                                        selection: [],
                                        history: [
                                            {
                                                filter: [],
                                                groupBy: ["component"]
                                            }
                                        ],
                                        currentHistory: 0
                                    }, () => {
                                        this.setState({opened: false});
                                    });
                                }
                            },
                            {
                                text: "Hozzáadás" + (this.state.selection.length > 0 ? " (" + this.state.selection.length + " db)" : ""),
                                props: {color: "primary", disabled: !this.state.selection.length || this.state.isLoading},
                                onClick: async () => {
                                    this.setState({isLoading: true}, async () => {
                                        try {
                                            await postData({
                                                action: this.state.componentConfig.componentname + '.copyAction',
                                                id: this.state.selection.map((item) => item[this.state.componentConfig.idfield]),
                                                component: this.props.component,
                                                component_id: this.props.component_id,
                                            });
                                            this.setState({
                                                isLoading: false,
                                                selection: [],
                                                history: [
                                                    {
                                                        filter: [],
                                                        groupBy: ["component"]
                                                    }
                                                ],
                                                currentHistory: 0
                                            }, () => {
                                                this.setState({opened: false});
                                                this.props.onComplete && this.props.onComplete();
                                            });
                                        } catch (e) {
                                            console.error(e);
                                            this.setState({
                                                isLoading: false
                                            });
                                        }
                                    });
                                }
                            }
                        ]}
                    >
                        <div className="figure-clone">
                            <div className="row">
                                <div className="col-md-12 actions">
                                    <Button
                                        tooltip="Vissza"
                                        color="default"
                                        icon={{lib: "fas", name: "arrow-left"}}
                                        onClick={this.onBack}
                                        disabled={this.state.currentHistory === 0 || this.state.isLoading || this.state.showOnlySelected}
                                    />
                                    <Button
                                        tooltip="Előre"
                                        color="default"
                                        icon={{lib: "fas", name: "arrow-right"}}
                                        onClick={this.onNext}
                                        disabled={this.state.currentHistory === (this.state.history.length - 1) || this.state.isLoading || this.state.showOnlySelected}
                                    />
                                    <Button
                                        color="default"
                                        tooltip={this.state.showOnlySelected ? "Minden kép mutatása" : "Csak a kiválaszott képek mutatása"}
                                        icon={this.state.showOnlySelected ? {lib: "fas", name: "eye"} : {lib: "fas", name: "eye-slash"}}
                                        disabled={this.state.isLoading}
                                        onClick={()=>this.setState({showOnlySelected: !this.state.showOnlySelected})}
                                    />
                                    <ol className="breadcrumb">
                                        {!this.state.showOnlySelected ? this.state.history[this.state.currentHistory].filter.map((filter, index) => <li>{filter.field === "component" ? remoteLanguageFormatter("figure")(filter.value) : <ComponentName component={this.state.history[this.state.currentHistory].filter[index-1].value} component_id={filter.value}>{filter.value}</ComponentName>}</li>) : <li>Kiválaszottak</li>}
                                    </ol>
                                    {!this.state.showOnlySelected && this.state.history[this.state.currentHistory].groupBy.length === 2 && this.state.history[this.state.currentHistory].filter.length === 1 ? <Select
                                        storeType="remote"
                                        objectValue={false}
                                        label={false}
                                        placeholder="Keresés..."
                                        component={this.state.history[this.state.currentHistory].filter[0].value}
                                        optionsTemplate={optionsTemplate(this.state.history[this.state.currentHistory].filter[0].value)}
                                        saveChanges={(field, value) => {
                                            this.onSelection({value: [{component: this.state.history[this.state.currentHistory].filter[0].value, component_id: value}]})
                                        }}
                                    /> : null}
                                </div>
                                {/*!this.isSelectable() && this.state.history[this.state.currentHistory].groupBy.length === 1 && <div className="col-md-12">
                                    <Select
                                        component={this.state.history[this.state.currentHistory].filter[0].value}
                                    />
                                </div>*/}
                            </div>
                            <SelectorGrid
                                type={(props) => <SelectorImage {...props} rowTemplate={this.rowTemplate} styleSelector={false} />}
                                ref={(el) => this.list = el}
                                componentConfig={this.state.componentConfig}
                                view={[this.state.componentConfig.idfield, "id", "path", "name", "url", "position", "component", "component_id"]}
                                selectionMode="multiple"
                                {...props}
                                onSelectionChange={this.onSelection}
                                className={classNames("full-size", {"folder-style": !this.isSelectable()})}
                                disabled={this.state.isLoading}
                            />
                        </div>
                    </Modal>
                </Portal>
                <Button
                    color="default"
                    tooltip="Képtár"
                    icon={{lib: "fas", name: "folder"}}
                    onClick={(e) => {
                        e && e.stopPropagation();
                        e && e.preventDefault();
                        this.setState({opened: true});
                    }}
                    {...buttonProps}
                />
            </Fragment>
        );
    }
}